import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import css from './PWasherPage.module.css';

const PWasherPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  return (
    <StaticPage
      title="Turn Your Pressure Washer into a Money-Making Machine with Lenddit"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description:
          'Discover how your idle pressure washer can generate a steady stream of income with Lenddit.',
        name: 'Pressure Washer Rental',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1>Turn Your Pressure Washer into a Money-Making Machine with Lenddit</h1>
          <h2>Introduction</h2>
          <p>
            Do you own a pressure washer that's gathering dust in your garage? What if we told you that your idle pressure washer could potentially generate a steady stream of income? Welcome to the world of Lenddit, where your tools don't just sit idle - they work for you!
          </p>

          <h2>The Demand for Pressure Washers</h2>
          <p>
            Pressure washers are in high demand, especially during the warmer months. Homeowners, businesses, and contractors often need them for various cleaning tasks, from washing decks and patios to removing dirt and grime from walls and driveways. However, not everyone wants to invest in buying a pressure washer, especially if they only need it for a one-time project. This is where renting becomes an attractive option.
          </p>

          <h2>The Potential Earnings</h2>
          <p>
            Let's crunch some numbers. The average rental price for a pressure washer ranges from $40 to $100 per day. If you were to rent out your pressure washer just twice a week at an average rate of $70 per day, you could earn $560 per month. Over a year, that's a potential income of $6,720! That's a significant amount of money for an item that would otherwise be sitting idle.
          </p>

          <h2>Why Choose Lenddit?</h2>
          <p>
            Lenddit is more than just a platform to rent out your tools. It's a community that values resourcefulness and cost-effectiveness. Here's why you should consider Lenddit for your pressure washer rental needs:
          </p>
          <ol>
            <li>
              Easy and Convenient: Listing your pressure washer on Lenddit is a breeze. With a user-friendly interface, you can have your listing up and running in no time.
            </li>
            <li>
              Secure Transactions: Lenddit ensures secure transactions between the equipment owner and the renter. You can rest easy knowing that your interests are protected.
            </li>
            <li>
              Wide Reach: Lenddit's platform gives your pressure washer exposure to a wide audience. This increases the chances of your equipment being rented out.
            </li>
          </ol>

          <h2>Conclusion</h2>
          <p>
            Renting out your pressure washer on Lenddit is not just about making extra money. It's about being part of a community that values resourcefulness and cost-effective solutions. So why wait? List your pressure washer on Lenddit today and let your tool work for you!
          </p>
          <p>Written by : The Lenddit Team</p>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default PWasherPage;
